module.exports = __webpack_public_path__ + "fonts/Montserrat-VariableFont.e6cb49e.ttf";